"use client";

import { Header } from "@/components/shared/public";
import AdditionalOption from "@/views/public/floor-plan-designs/AdditionalOption";
import DesignHolder from "@/views/public/floor-plan-designs/design-creator/DesignHolder";
import DesignDescription from "@/views/public/floor-plan-designs/DesignDescription";
import FurnitureOption from "@/views/public/floor-plan-designs/FurnitureOption";
import Hero from "@/views/public/floor-plan-designs/Hero";
import IndividualOption from "@/views/public/floor-plan-designs/IndividualOption";
import KitchenOption from "@/views/public/floor-plan-designs/KitchenOption";
import { useTranslations } from "next-intl";

export default function FloorPlanDesignsContent() {
  const t = useTranslations("floorPlanDesigns");
  return (
    <div className="[--h1-weight:500] [--heading-scale:0.6]">
      <Header
        title={t("head.title")}
        compact
        className="min-h-[200px] md:min-h-[230px]"
      />
      <p className="gs--page-column text-ring pt-8 text-left">
        {t("head.description")}
      </p>
      <DesignHolder />
      <FurnitureOption />
      <KitchenOption />
      <AdditionalOption />
      <DesignDescription />
      <IndividualOption />
      <Hero />
    </div>
  );
}
